import { AdminAccountIndemnitySummary } from "@portal/api/account/admin";
import { FC } from "react";
import { IndemnitorRow } from "./IndemnitorRow";

export type AdminAccountRequiredIndemnitorsListProps = {
	indemnitySummary: AdminAccountIndemnitySummary;
	/** Companies to flag for a missing address, with where the underwriter adds it. */
	missingAddress?: { companyIds: ReadonlySet<string>; onAddAddress: () => void };
};

export const AdminAccountRequiredIndemnitorsList: FC<AdminAccountRequiredIndemnitorsListProps> = ({
	indemnitySummary,
	missingAddress,
}) => {
	return (
		<div
			data-testid="admin-account-required-indemnitors"
			className="flex flex-col space-y-[14px] w-full min-w-[70%] auto-rows-min"
		>
			<div className="flex flex-col space-y-2">
				{indemnitySummary.requiredIndemnitors.companies.map((indemnitor, index) => (
					<IndemnitorRow
						key={index}
						name={indemnitor.name}
						onAddAddress={
							missingAddress?.companyIds.has(indemnitor.id)
								? missingAddress.onAddAddress
								: undefined
						}
					/>
				))}
				{indemnitySummary.requiredIndemnitors.individuals.map((indemnitor, index) => (
					<IndemnitorRow key={index} name={indemnitor.name} email={indemnitor.email} />
				))}
			</div>
		</div>
	);
};
